var articlesData = [];
var current = ''

export const deploy = (data, currentPath) => {
    current = currentPath
    // 遍历文章列表
    for (const article of data) {
        // 如果映射对象中存在对应的处理函数，则调用该函数
        if (deployActions[article.label]) {
            deployActions[article.label](article);
        }
    }

    return articlesData
}

export const deployActions = {
    appStore: (article) => {
        articlesData.appStore = article.content;
    },
    // NaAppStore: (article) => {
    //     if (isNa) {
    //         articlesData.appStore = article.content;
    //     }
    // },
    googlePlay: (article) => {
        articlesData.googlePlay = article.content;
    },
    // NaGooglePlay: (article) => {
    //     if (isNa) {
    //         articlesData.googlePlay = article.content;
    //     }
    // },
    fbAppStore: (article) => {
        if (current.includes("FB")) {
            articlesData.appStore = article.content;
        }
    },
    // NaFbAppStore: (article) => {
    //     if (current.includes("FB") && isNa) {
    //         articlesData.appStore = article.content;
    //     }
    // },
    ggAppStore: (article) => {
        if (current.includes("GG")) {
            articlesData.appStore = article.content;
        }
    },
    // NaGgAppStore: (article) => {
    //     if (current.includes("GG") && isNa) {
    //         articlesData.appStore = article.content;
    //     }
    // },
    ttAppStore: (article) => {
        if (current.includes("TT")) {
            articlesData.appStore = article.content;
        }
    },
    // NaTtAppStore: (article) => {
    //     if (current.includes("TT") && isNa) {
    //         articlesData.appStore = article.content;
    //     }
    // },
    fbLink: (article) => {
        articlesData.fbLink = article.content;
    },
    appStoreImg: (article) => {
        articlesData.appStoreImg = article.content;
    },
    googlePlayImg: (article) => {
        articlesData.googlePlayImg = article.content;
    },
    discordShare: (article) => {
        articlesData.discordShare = article.content;
    },
    fbPageEN: (article) => {
        articlesData.fbPageEN = article.content;
    },
    fbPageCN: (article) => {
        articlesData.fbPageCN = article.content;
    },
    fbPageTH: (article) => {
        articlesData.fbPageTH = article.content;
    },
    QRcode: (article) => {
        articlesData.QRcode = article.content;
    },
    gwQRcode: (article) => {
        articlesData.gwQRcode = article.content;
    },
    popupAppstoreImg: (article) => {
        articlesData.popupAppstoreImg = article.content;
    },
    appStoreImgWap: (article) => {
        articlesData.appStoreImgWap = article.content;
    },
    googlePlayImgWap: (article) => {
        articlesData.googlePlayImgWap = article.content;
    },
    popupGooglePlayImg: (article) => {
        articlesData.popupGooglePlayImg = article.content;
    },
    carveUpEN: (article) => {
        articlesData.carveUpEN = article.content;
    },
    carveUpCN: (article) => {
        articlesData.carveUpCN = article.content;
    },
    carveUpTH: (article) => {
        articlesData.carveUpTH = article.content;
    },
    payUrl: (article) => {
        articlesData.payUrl = article.content;
    },
    payUrl2CN: (article) => {
        articlesData.payUrl2CN = article.content;
    },
    payUrl2EN: (article) => {
        articlesData.payUrl2EN = article.content;
    },
    payUrl2TH: (article) => {
        articlesData.payUrl2TH = article.content;
    },
    huawei: (article) => {
        articlesData.huawei = article.content;
    },
    apk: (article) => {
        articlesData.apk = article.content;
    },
    doubleStore: (article) => {
        articlesData.doubleStore = article.content;
    },
};